import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import windowSize from 'react-window-size'
import { Utils } from './Utils'
import { history } from '../store'
import { Link } from 'react-router-dom'
import { env } from '../constants/env'
import '../css/TitleAppBar.css'
Utils.init('TitleAppBar')

class TitleAppBar extends React.Component {
	static propTypes = {
		locale: PropTypes.object.isRequired,
		location: PropTypes.object.isRequired,
		windowWidth: PropTypes.number.isRequired,
	}

	handleChange = (value) => {
		Utils.log('TitleAppBar', 'handleChangeTab ' + value)
		Utils.logobj('TitleAppBar', 'handleChangeTab ', this.props.location)
		history.push(value)
	}

	render() {
		Utils.logobj('TitleAppBar', 'render ', this.props.location)
		return (
			<div className='titleappbar-div'>
				<Link
					to='/'
					className='title-menu-link'>
					<img
						src='static/images/GEK_Logo.png'
						style={{ height: 40 }}
						alt='Logo'
					/>
					<h1 className='titleappbar-h1 h1-title-font'>{this.props.locale.title}</h1>
					{env.production ? '' : <div className='titleappbar-env'>{env.env}</div>}
				</Link>
			</div>
		)
	}
}

const mapStateToProps = (state) => ({
	locale: state.locale.locale,
	location: state.router.location,
})

export default windowSize(connect(mapStateToProps)(TitleAppBar))



// WEBPACK FOOTER //
// ./src/components/TitleAppBar.js